import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from "."
import { URI } from "../../constants/URI"
import { setUsers } from "../slices/usersSlice"
import { store } from "../store"


export const getUsers = async (body) => {
    const res = await handlePostRequest(URI.users, body)
    if (res?.ack) store.dispatch(setUsers(res?.users || []))
    return res
}

export const addUser = async (body) => {
    const res = await handlePostRequest(URI.user, body)
    return res
}

export const getUser = async (id) => {
    const res = await handleGetRequest(URI.user, null, {
        params: { id },
    })
    return res
}

export const updateUser = async (body) => {
    const res = await handlePutRequest(URI.user, body)
    return res
}

export const deleteUser = async (body) => {
    const res = await handleDeleteRequest(URI.user, body)
    if (res?.ack) getUsers()
    return res
}

export const getAssignUsersList = async (id) => {
    const res = await handleGetRequest(URI.assign_users, null, {
        params: { id },
    })
    return res
}

export const addAssignUser = async (body) => {
    const res = await handlePostRequest(URI.assigned_user, body)
    return res
}

export const getAssignedUsers = async (id) => {
    const res = await handleGetRequest(URI.assigned_users, null, {
        params: { id },
    })
    return res
}

export const deleteAssignedUser = async (body) => {
    const res = await handleDeleteRequest(URI.assigned_user, body)
    return res
}

export const addAssignCustomer = async (body) => {
    const res = await handlePostRequest(URI.assigned_customer, body)
    return res
}

export const getAssignedCustomers = async (id) => {
    const res = await handleGetRequest(URI.assigned_customers, null, {
        params: { id },
    })
    return res
}

export const deleteAssignedCustomer = async (body) => {
    const res = await handleDeleteRequest(URI.assigned_customer, body)
    return res
}